import { ReachApiResponse } from '../../../ReachApi/ReachAPI';
import { ILogMechanism } from '../../../Logging/ILogMechanism';
import { LogLevel } from '../../../Logging/LogLevel';
import { Nullish } from '../../../Utility/Nullish';
import { Signage } from '../../../Signage';
import { ReachAPI } from '../../../ReachApi';
import { Log } from '../Log';

//todo: Move to ReachApi code once it has been converted to TypeScript
//todo: document what these codes are and what they are used for
type ReachApiGetNoticeCodesResponse = ReachApiResponse & { codes: Record<string, unknown> };

type ReachApiLogEntry = {
    level: LogLevel;
    message: string;
    code?: string | Nullish;
    source?: string;
    data?: unknown;
};

export class LogToApi implements ILogMechanism {
    #logCodes: Record<string, unknown> = {};

    #entryCache: ReachApiLogEntry[] = [];

    #initialized = false;

    constructor() {
        this.initialize();
    }

    private async initialize(): Promise<void> {
        try {
            this.#logCodes = await this.getLogCodes();
            this.#initialized = true;

            this.flushCachedEntries();
        } catch (error: unknown) {
            Log.Error('Failed to initialize `LogToApi`.', null, __fileline, error);
        }
    }

    private flushCachedEntries() {
        this.#entryCache.forEach((entry) => {
            this.LogMessage(entry.level, entry.message, entry.code, entry.source, entry.data);
        });
        this.#entryCache = [];
    }

    private getLogCodes(): Promise<Record<string, unknown>> {
        const retryDuration = 5000;
        const rejectError = new Error(`No codes sent, retrying in ${retryDuration}ms`);

        const noticeCodePromise = new Promise<Record<string, unknown>>((resolve, reject) => {
            ReachAPI.signage
                .getNoticeCodes()
                .done((result: ReachApiGetNoticeCodesResponse) => {
                    if (result.codes) {
                        resolve(result.codes);
                    } else {
                        //No codes sent, reject and check again
                        reject(rejectError);
                    }
                })
                .fail(function () {
                    reject(rejectError);
                });
        });

        return noticeCodePromise.catch(() => {
            const retryPromise = new Promise((resolve) => {
                setTimeout(resolve, retryDuration);
            });

            return retryPromise.then(() => {
                return this.getLogCodes();
            });
        });
    }

    LogMessage(
        level: LogLevel,
        message: string,
        code: string | Nullish,
        source?: string,
        data?: unknown
    ): void {
        if (!Signage.playerUuid) {
            return;
        }

        // sanitize data
        if (data) {
            data = JSON.parse(JSON.stringify(data));
        }

        if (!this.#initialized) {
            this.#entryCache.push({
                level: level,
                message: message,
                code: code,
                source: source,
                data: data,
            });
        } else {
            // Only log known error codes to the server
            // Also, ignore
            if (code && typeof this.#logCodes[code] !== 'undefined') {
                const codeNumber = this.#logCodes[code];

                ReachAPI.signage
                    .putNotice(Signage.playerUuid, codeNumber, message, data)
                    .fail(function (jqXHR: unknown, textStatus: unknown, errorThrown: unknown) {
                        Log.Error('Failed to log message to server', null, __fileline, {
                            error: {
                                jqXHR: jqXHR,
                                textStatus: textStatus,
                                errorThrown: errorThrown,
                            },
                            message: {
                                level: level,
                                message: message,
                                code: code,
                                source: source,
                                data: data,
                            },
                        });
                    });
            }
        }
    }
}
